export default {"src":"/_next/static/media/solana-ventures.5100b35c.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};